import { Committee } from './committee.model';
import { User } from './user.model';

export interface CommitteeMember {
    committee: Committee;
    user: User;
    role: string;
    creationTime: string | Date;
}

export const committeeMemberRole = {
    leader: 'leader',
    vicePresident: 'vice_president',
    rapporteur: 'rapporteur',
    member: 'member',
    rapporteurMember: 'rapporteur_member',
} as const;
